<template>
  <v-container>
    <div class="row">
      <div class="col-md-10 col-sm-10 col-xs-12">
        <v-card class="top">
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Primer año financiero"
                @click="pickFile('0')"
                v-model="FileName[0]"
                :disabled="this.filesDca['daf'][0]['saved'] == 'si'"
                prepend-icon="attach_file"
              ></v-text-field>
              <input
                type="file"
                id="file0"
                ref="myFiles0"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('0')"
                multiple
              >
            </v-flex>

            <v-flex md2 xs1>
              <v-btn v-if="this.filesDca['daf'][0]['saved'] == 'si'"  fab outline small color="#394049" v-on:click="downloadFile('0')"><v-icon dark>save_alt</v-icon></v-btn>
              <v-btn v-if="this.filesDca['daf'][0]['saved'] == 'no'" fab outline small color="#EC6A12" v-on:click="submitFile('0')" :disabled="disabled[0]"><v-icon dark>publish</v-icon></v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Segundo año financiero"
                @click="pickFile('1')"
                v-model="FileName[1]"
                :disabled="this.filesDca['daf'][1]['saved'] == 'si'"
                prepend-icon="attach_file"
              ></v-text-field>
              <input
                type="file"
                id="file1"
                ref="myFiles1"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('1')"
                multiple
              >
            </v-flex>

            <v-flex md2 xs1>
              <v-btn v-if="this.filesDca['daf'][1]['saved'] == 'si'" fab outline small color="#394049" v-on:click="downloadFile('1')"><v-icon dark>save_alt</v-icon></v-btn>
              <v-btn v-if="this.filesDca['daf'][1]['saved'] == 'no'" fab outline small color="#EC6A12" v-on:click="submitFile('1')" :disabled="disabled[1]"><v-icon color="black" dark>publish</v-icon></v-btn>
              
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Tercer año financiero"
                @click="pickFile('2')"
                v-model="FileName[2]"
                :disabled="this.filesDca['daf'][2]['saved'] == 'si'"
                prepend-icon="attach_file"
              ></v-text-field>
              <input
                type="file"
                id="file2"
                ref="myFiles2"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('2')"
                multiple
              >
            </v-flex>

            <v-flex md2 xs1>
              <v-btn v-if="this.filesDca['daf'][2]['saved'] == 'si'" fab outline small color="#394049" v-on:click="downloadFile('2')"><v-icon dark>save_alt</v-icon></v-btn>
              <v-btn v-if="this.filesDca['daf'][2]['saved'] == 'no'" fab outline small color="#EC6A12" v-on:click="submitFile('2')" :disabled="disabled[2]"><v-icon dark>publish</v-icon></v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
    </div>
  </v-container>
</template>


<script>

export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      auth: {
        headers: {Authorization:'' + this.$session.get('jwt')} 
      },
      path: "",
      disabled: [
        true,true,true
      ],
      file: "",
      filesDca: "",
      filess: {
        0: "",
        1: "",
        2: ""

      },
      FileName: {
        0: "",
        1: "",
        2: ""
      },
    };
  },

  mounted(){


             this.$http.get('http://localhost:8089/uploadFileDcaEtc/getByCcValor?ccValor=40',this.auth).then(response => {
                 this.filesDca = response.data
                 //console.log(this.filesDca)
                  //console.log(this.filesDca['daf'][1])
             }, (error) => {
                 console.error(error.status)
             });
  },

  methods: {
    /*
        Submits the file to the server
      */
    submitFile(index) {
      /*
                Initialize the form data
            */

      let formData = new FormData();
      var name=this.filess[index].name
      //console.log("indice: " + index)
      /*
                Add the form data we need to submit
            */
      formData.append("file", this.filess[index]);
      //console.log(formData);

      /*
          Make the request to the POST /single-file URL
        */

      axios
        .post(process.env.ROOT_API + "/uploadFileDcaEtc/createFile?cc=40", formData,this.auth)
        .then(response => {
          //console.log("SUCCESS!!");
          //console.log(response.data)
          this.path = response.data
          this.filesDca.daf[index]['saved'] = "si"
          this.filesDca.daf[index]['path'] = response.data[0]
          this.filesDca.daf[index]['name'] = response.data[1]
          alert("Archivo: "+ name + " fue cargado exitosamente.")
        })
        .catch(error => {
          //console.log("FAILURE!!");
          alert("Error al cargar el archivo" + name + " ," + error)
        }).then(response => {
          axios.post("http://localhost:8089/uploadFileDcaEtc/updateFileValue?ccValor=40&tipoData=daf", this.filesDca.daf,this.auth)
          .then(response => {
            //console.log(response.data)
            //console.log("funcionando")
          }).catch(error => {
            console.error(error)
          })
        })
    },

    /*
        Handles a change on the file upload
      */
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      //console.log(this.file);
    },

    previewFiles(index) {
      //console.log(index)
      this.filess[index] = this.$refs['myFiles'+ index].files[0];
      //console.log(this.filess);
      this.FileName[index]= this.$refs['myFiles'+ index].files[0].name;
      
    },
    pickFile(index) {
      //console.log("entrando a pick file")
      this.$refs['myFiles'+ index].click();
      this.disabled[index] = false
    },
    // TODO
    downloadFile (index){
      //console.log("Descargando archivo ....")
      var pathFile = this.convertPath(this.filesDca.daf[index]['path'])
      var nameFile = this.filesDca.daf[index]['name']
      //console.log(nameFile)
      axios.get("http://localhost:8089/uploadFileDcaEtc/downloadFile?dir="+pathFile, {responseType: 'arraybuffer', headers: {Authorization:'' + this.$session.get('jwt')} })
      .then(response => {
        //console.log("archivo descargado ....")
        //console.log(response)
        this.forceFileDownload(response,nameFile)
      }).catch(error => {
        console.error(error)
      })
    },

    convertPath(string) {
      var info = string
        .split("\\")
        .join("/");
      return info;
    },

    forceFileDownload(response,nameFile){
      //console.log("Aqui va el header")
      //console.log(response.headers)
      const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', nameFile) //or any other extension
      document.body.appendChild(link)
      link.click()
    },
  }
};
</script>


<style scoped>
.v-card{
  
  margin-bottom: 1%;
  padding-right: 3%;
  padding-left: 3%;
  padding-top: 0.5%;
}

.top{
margin-top: 50px;
}

.bot{
  margin-bottom: 50px;
}

.primary--text {
  color: #ec6a12 !important;
  caret-color: #ec6a12 !important;
}

.v-text-field .v-label--active {
  color: #ec6a12 !important;
}

.v-btn--floating.v-btn--small {
    height: 35px !important;
    width: 35px !important;
    margin-top: 15px!important;
}


</style>


// WEBPACK FOOTER //
// src/components/primeraEtapa/Daf.vue